import { render, staticRenderFns } from "./ContextMenuBase.vue?vue&type=template&id=023eb603&scoped=true&lang=pug&"
import script from "./ContextMenuBase.vue?vue&type=script&lang=js&"
export * from "./ContextMenuBase.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuBase.vue?vue&type=style&index=0&id=023eb603&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023eb603",
  null
  
)

export default component.exports